import { useQuery } from "@tanstack/react-query"
import { getProductCategories } from "@/lib/api/product.api"
import { useAuthStore } from "@/store/auth.store"

export function useProductCategories() {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["product-categories"],
    queryFn: () => getProductCategories(accessToken ?? undefined),
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchOnWindowFocus: false,
  })
}